<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        
          <el-col :span="6">
            <el-form-item label="养老院名称" prop="nursinghomeId">
              <el-select
                v-model="searchForm.nursinghomeId"
                style="width: 100%"
                placeholder="请选择养老院名称"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        <el-col :span="6">
          <el-form-item label="类型名称" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="物料名称"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="所属设备大类" prop="deviceCategory">
            <!-- <el-input
              clearable
              v-model="searchForm.deviceCategory"
              placeholder="物料编码"
              maxlength="100"
            ></el-input> -->
            <el-select v-model="searchForm.deviceCategory" 
                placeholder="所属设备大类"
                style="width:100%">
                <el-option
                  v-for="item in deviceCategoryList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="是否主机" prop="isHostMachine">
            <el-select v-model="searchForm.isHostMachine" 
                placeholder="是否主机"
                style="width:100%">
                <el-option
                  v-for="item in yesNoList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
          </el-form-item>
        </el-col> -->

        <el-col :span="6">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>

      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button  v-if="permissionList.addBtn" type="primary" size="small" @click="addNursingForm"> 新 增</el-button>
        <el-button  v-if="permissionList.delBtn" type="danger" size="small" @click="batchDeleteFun(selectionIds)"> 删 除</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button  v-if="permissionList.viewBtn" type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
        <el-button  v-if="permissionList.editBtn" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <el-button  v-if="permissionList.delBtn" type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>
      </template>
    </avue-crud>
    <hr-dialog
      :title="formModel==='add'?'新增':formModel==='edit'?'编辑':'查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <NursingForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></NursingForm>
      </template>
    </hr-dialog>
  </basic-container>
</template>
  <script>
import { getnursinghomeIdList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList, stockWarnDelete } from '../api/nursingManage.js';
import NursingForm from './typeForm.vue';
import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';

import { getDeviceTypePage, deviceTypeRemove, getNursinghome } from '../api/serveItemManage';
import { getDictionary } from '@/api/common.js';
export default {
  components: { searchFromShow, NursingForm },
  data() {
    return {
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        nursinghomeId: '',
        warehouseId: '',
        type: '0',
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },
      typeDice: [
        {
          dictKey: '0',
          dictValue: '按仓库',
        },
        {
          dictKey: '1',
          dictValue: '按总库存',
        },
      ],
      nursinghomeIdList: [],

      option: {
        selection: true,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '类型名称',
            prop: 'name',
          },
          {
            label: '所属设备大类',
            prop: 'deviceCategory',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_device_category_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '是否主机',
            prop: 'isHostMachine',
            dicUrl: '/api/blade-system/dict/dictionary?code=yes_no',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      deviceCategoryList:[],
      yesNoList:[],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.nursingHome_deviceType_view, false),
        addBtn: this.vaildData(this.permission.nursingHome_deviceType_add, false),
        editBtn: this.vaildData(this.permission.nursingHome_deviceType_edit, false),
        delBtn: this.vaildData(this.permission.nursingHome_deviceType_del, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    addNursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    batchDeleteFun(ids) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deviceTypeRemove(ids).then((res) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deviceTypeRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    exportFun() {
      let params = this.tool.formateObjToParamStr(this.searchForm);
      this.tool.downloadFile(
        `/api/v4ward/warehouse/stockWarn/exportStockWarmSetting?${
          this.website.tokenHeader
        }=${getToken()}&${params}`
      );
    },
    selectionChange(val) {
      this.selectionList = val;
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.selectionIds = Ids.join(',');
    },
    // 数据导出
    exportExcel(data) {
      let saveIds = data.exportExcelSelectionRadio == '1' ? '' : this.selectionIds;

      if (saveIds.length == 0 && data.exportExcelSelectionRadio == 2) {
        this.$message({
          message: '请选择需要导出的数据！',
          type: 'warning',
        });
        return;
      }
      this.$confirm('是否导出综合巡查记录数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        let nursinghomeId = this.exportForm.nursinghomeId;

        if (data.exportExcelSelectionRadio == 2) {
          this.tool.downloadFile(
            `/api/v4ward/personal/config/export/default/taskGeneralExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${
              data.configExport
            }&nursinghomeId=${nursinghomeId}&exportIds=${saveIds}`
          );
        } else {
          // 将条件参数拼接为路由传参格式
          let paramFormString = this.tool.objToform(this.exportForm);
          //
          this.tool.downloadFile(
            `/api/v4ward/personal/config/export/default/taskGeneralExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&${paramFormString}`,
            'abc.xlsx',
            'xlsx/xls'
          );
        }
      });
    },
    editRecord(row) {
      this.formModel = 'edit';
      this.formRow = row;
      this.editVisible = true;
      this.nursingFormVisible = true;
    },
    viewRecord(row){
      this.formModel = 'view';
      this.formRow = row;
      this.editVisible = true;
      this.nursingFormVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    // viewRecord(row) {
    //   this.alarmRuleTittle = '查看';
    //   this.rowInfo = row;

    //   this.alarmRuleModel = 'view';
    //   this.alarmRuleVisible = true;
    // },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        nursinghomeId: this.searchForm.nursinghomeId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    nursinghomeIdChange(nursinghomeId) {
      this.searchForm.warehouseId = '';
      this.warehouseList = [];
      getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
        this.warehouseList = res.data;
      });
      // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.nursinghomeId);
      // this.getCanteen(this.searchForm.nursinghomeId);
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      
      // getNursinghome().then((res) => {
      //   this.nursinghomeIdList = res.data;
      // });
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
          this.onLoad();
        }
      });
      // getDictionary('nursinghome_device_category_type').then((res) => {
      //   this.deviceCategoryList = res.data;
      // });
      getDictionary('yes_no').then((res) => {
        this.yesNoList = res.data;
      });
    },

    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        getDeviceTypePage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
  
  <style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
  <style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
  